export enum ENativeBadgeType {
  LIKABLE_COMMENT = 'LIKABLE_COMMENT',
  APPRECIATED_COMMENT = 'APPRECIATED_COMMENT',
  LOVED_COMMENT = 'LOVED_COMMENT',

  LIKABLE_POST = 'LIKABLE_POST',
  APPRECIATED_POST = 'APPRECIATED_POST',
  LOVED_POST = 'LOVED_POST',

  INTERESTING_POST = 'INTERESTING_POST',
  ENGAGING_POST = 'ENGAGING_POST',
  POPULAR_POST = 'POPULAR_POST',
}

export const NATIVE_BADGE_DETAILS: Record<
  ENativeBadgeType,
  { title: string; description: string }
> = {
  LIKABLE_COMMENT: {
    title: 'Likable Comment',
    description: 'Authored a comment with 1 or more likes from other members.',
  },
  APPRECIATED_COMMENT: {
    title: 'Appreciated Comment',
    description: 'Authored a comment with 3 or more likes from other members.',
  },
  LOVED_COMMENT: {
    title: 'Loved Comment',
    description: 'Authored a comment with 5 or more likes from other members.',
  },
  LIKABLE_POST: {
    title: 'Likable Post',
    description: 'Authored a post with 1 or more likes from other members.',
  },
  APPRECIATED_POST: {
    title: 'Appreciated Post',
    description: 'Authored a post with 3 or more likes from other members.',
  },
  LOVED_POST: {
    title: 'Loved Post',
    description: 'Authored a post with 5 or more likes from other members.',
  },
  INTERESTING_POST: {
    title: 'Interesting Post',
    description: 'Authored a post with 1 or more comments from other members.',
  },
  ENGAGING_POST: {
    title: 'Engaging Post',
    description: 'Authored a post with 3 or more comments from other members.',
  },
  POPULAR_POST: {
    title: 'Popular Post',
    description: 'Authored a post with 5 or more comments from other members.',
  },
};
